/**
 * Labstep
 *
 * @module components/Group/SearchSelect
 * @desc Search groups
 */

import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import type React from 'react';
import type { GroupSearchSelectProps } from './types';

export const GroupSearchSelect: React.FC<GroupSearchSelectProps> = (
  props,
) => <SearchSelect searchKey="name" entityName="group" {...props} />;
